import * as React from 'react';
/**
 *
 * Original name: archive
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A390
 *
 */
export const ArchivePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 63", fill: "none", ...props },
    React.createElement("path", { d: "M34 28.547h-4a11.247 11.247 0 0 0-5.894-6.115l1.789-3.522A16.78 16.78 0 0 1 30 21.73V10.827h4V21.73a16.78 16.78 0 0 1 4.106-2.818l1.789 3.522A11.252 11.252 0 0 0 34 28.547Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m37.974 33.348.116-1.848H56v20.672H8V31.5h17.91l.116 1.848c.255 4.058 2.209 6.027 5.974 6.027s5.719-1.969 5.974-6.027ZM12 35.438v12.796h40V35.437H41.734c-.962 4.969-4.5 7.876-9.734 7.876s-8.772-2.907-9.734-7.876H12Z", fill: "currentColor" })));
